/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React from 'react';
import PropTypes from "prop-types";
export var BreadcrumbResponsiveMaxCount = function BreadcrumbResponsiveMaxCount() {
  return /*#__PURE__*/React.createElement("div", null);
};
export var BreadcrumbProps = () => <div />;
BreadcrumbProps.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  /**
     * Visible label of the breadcrumb
     */
  text: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  /**
     * Force a max-width on the breadcrumb text
     */
  truncate: PropTypes.bool
};
try {
  BreadcrumbResponsiveMaxCount.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3672379046/src/src-docs/src/views/breadcrumbs/props.tsx',
    description: '',
    displayName: 'BreadcrumbResponsiveMaxCount',
    methods: [],
    props: {
      xs: {
        defaultValue: null,
        description: '',
        name: 'xs',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      s: {
        defaultValue: null,
        description: '',
        name: 's',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      m: {
        defaultValue: null,
        description: '',
        name: 'm',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      l: {
        defaultValue: null,
        description: '',
        name: 'l',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      xl: {
        defaultValue: null,
        description: '',
        name: 'xl',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      xxl: {
        defaultValue: null,
        description: '',
        name: 'xxl',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      xxxl: {
        defaultValue: null,
        description: '',
        name: 'xxxl',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['CommonProps']
  };
} catch (e) {}
try {
  BreadcrumbProps.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3672379046/src/src-docs/src/views/breadcrumbs/props.tsx',
    description: '',
    displayName: 'BreadcrumbProps',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      text: {
        defaultValue: null,
        description: 'Visible label of the breadcrumb',
        name: 'text',
        parent: undefined,
        declarations: [{
          fileName: 'src/src/components/breadcrumbs/breadcrumbs.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ReactNode'
        }
      },
      href: {
        defaultValue: null,
        description: '',
        name: 'href',
        parent: undefined,
        declarations: [{
          fileName: 'src/src/components/breadcrumbs/breadcrumbs.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      onClick: {
        defaultValue: null,
        description: '',
        name: 'onClick',
        parent: undefined,
        declarations: [{
          fileName: 'src/src/components/breadcrumbs/breadcrumbs.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLAnchorElement>'
        }
      },
      truncate: {
        defaultValue: null,
        description: 'Force a max-width on the breadcrumb text',
        name: 'truncate',
        parent: undefined,
        declarations: [{
          fileName: 'src/src/components/breadcrumbs/breadcrumbs.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: ['CommonProps']
  };
} catch (e) {}